var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "77px",
    height: "77px",
    viewBox: "0 0 77 77",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "108.964083%",
    y1: "-16.2692776%",
    x2: "14.5342938%",
    y2: "138.884943%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F7F7F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs_desktopscreens-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "step3_egift_email",
    transform: "translate(-415.000000, -439.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(415.000000, 439.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6-Copy-2",
    fill: "url(#linearGradient-1)",
    x: 0,
    y: 0,
    width: 77,
    height: 77
  }), /*#__PURE__*/React.createElement("text", {
    id: "None",
    fontFamily: "Helvetica",
    fontSize: 8,
    fontWeight: "normal",
    letterSpacing: 0.56,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 28.2333333,
    y: 42.4940416
  }, "None")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/none.9ae26be2a87629345e58cfb6652827ad.svg";
export { ForwardRef as ReactComponent };